// Helper to get CSS variable value for inline styles
export const getTableHeaderStyle = (): React.CSSProperties => ({
  backgroundColor: 'var(--bg-elevated)',
  borderBottom: '2px solid var(--border-color)',
});

export const getTableRowStyle = (): React.CSSProperties => ({
  borderBottom: '1px solid var(--border-color)',
});

export const getSecondaryTextStyle = (): React.CSSProperties => ({
  color: 'var(--text-secondary)',
});

export const getDividerStyle = (): React.CSSProperties => ({
  borderTop: '2px solid var(--border-color)',
});

export const getBorderStyle = (): React.CSSProperties => ({
  borderBottom: '1px solid var(--border-color)',
});
